var map = {
	"./activity.svg": "6736",
	"./admin.svg": "ced6",
	"./advertise.svg": "cb0d",
	"./auditSheet.svg": "1e24",
	"./channelList.svg": "16f8",
	"./chart.svg": "c829",
	"./classificationList.svg": "0240",
	"./commodityList.svg": "5bd6",
	"./dashboard.svg": "f782",
	"./example.svg": "30c3",
	"./eye-open.svg": "d7ec",
	"./eye.svg": "4df5",
	"./form.svg": "eb1b",
	"./gift.svg": "3d7b",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./love.svg": "e05b",
	"./manage.svg": "723e",
	"./matchRule.svg": "27e2",
	"./message.svg": "47ff",
	"./nested.svg": "dcf8",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./price.svg": "5a55",
	"./reward.svg": "452a",
	"./sms.svg": "694b",
	"./table.svg": "47f1",
	"./task.svg": "771b",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";